import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { DocumentosService } from '../services/documentos.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as Datepicker from 'js-datepicker';
import { UploaderService } from '../services/uploader.service';

import * as _ from 'lodash';

@Component({
  selector: 'app-documentos-edit',
  templateUrl: './documentos-edit.component.html',
  styleUrls: ['./documentos-edit.component.css'],
  animations: [loadingFade]
})
export class DocumentosEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public documento_id = null;

  public formDocumento: FormGroup;

  public file;
  public file_name;
  public file_name_upload;

  public documento_data_dp;
  public base64Arquivo;

  public img_extensions = ['png', 'jpg', 'jpeg', 'pdf'];

  private imageSrc: string = '';

  constructor(private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private documentoSvc: DocumentosService,
    private uploaderSvc: UploaderService,
  ) { }

  ngOnInit() {
    this.criaForm();
    this.loading = true;

    this.route.params.subscribe(params => {
      if (params.id) {
        this.documento_id = params.id;
        //console.log(this.documento_id);
        this.documentoSvc.getDocumento(params.id).then((data: any) => {
          this.preencheForm({
            documento_id: null,
            documento_nome: data.documento_nome,
            documento_data: moment(data.documento_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            documento_descricao: data.documento_descricao,
            documento_arquivo: null
          });
          this.file_name = data.documento_arquivo_nome;
          this.loading = false;
        });
      }
      else {
        this.loading = false;
      }
    });
  }


  criaForm() {
    this.formDocumento = this.fb.group({
      documento_id: null,
      documento_nome: ['', [Validators.required]],
      documento_descricao: ['', [Validators.required]],
      documento_data: ['', [Validators.required]],
      documento_arquivo: [null, [Validators.required]]
    });

    moment.locale('pt-Br');
    this.documento_data_dp = Datepicker('#documento_data', {
      customMonths: moment.months(),
      customDays: moment.weekdaysShort(),
      overlayPlaceholder: 'Preencha o ano',
      overlayButton: 'Enviar',
      formatter: (element, date) => {
        let formatted = moment(date).format('DD/MM/YYYY');
        this.formDocumento.controls['documento_data'].setValue(formatted);
      }
    });
  }

  preencheForm(dados) {
    this.formDocumento.setValue(dados);
  }

  enviaDocumento(e) {

    //console.log("[enviaDocumento]");
    //console.log("[getBase64 = imageSrc]=" + this.imageSrc);


    if (this.formDocumento.valid) {
      this.submitting = true;

      let toSend = this.formDocumento.value;

      if (this.file.length > 0) {

        let formData = new FormData();
        formData.append("file", this.file[0], this.file_name_upload);

        if(this.file[0].size < 15000000){
          this.uploaderSvc.sendFile(formData).then((data) => {

            toSend.documento_status = 1;
            toSend.documento_arquivo = this.file_name_upload != null ? this.file_name_upload : '';
            toSend.documento_arquivo_nome = this.file_name != null ? this.file_name : '';
            toSend.documento_arquivo = this.imageSrc;
            if (this.documento_id === null) { // criar

              console.log("[toSend] = " , toSend);
              this.documentoSvc.criaDocumento(toSend).then((data) => {
                console.log('resp', data);
                Swal.fire({
                  type: 'success',
                  title: 'Documento cadastrado com sucesso!',
                  onClose: () => {
                    this.router.navigate(['home/formularios']);
                  }
                });
              }).catch(err => {
                console.log(err);
                this.submitting = false;
                Swal.fire({
                  type: 'error',
                  title: 'Ops! Algo de errado aconteceu!',
                  text: 'Tente novamente mais tarde.'
                });
              });
            }
            else { // editar
              toSend.documento_id = this.documento_id;
              this.documentoSvc.editaDocumento(toSend).then((data) => {
                console.log('resp', data);
                Swal.fire({
                  type: 'success',
                  title: 'Documento cadastrado com sucesso!',
                  onClose: () => {
                    this.router.navigate(['home/formularios']);
                  }
                });
              }).catch(err => {
                console.log(err);
                this.submitting = false;
                Swal.fire({
                  type: 'error',
                  title: 'Ops! Algo de errado aconteceu!',
                  text: 'Tente novamente mais tarde.'
                });
              });
            }
          }).catch((err) =>{
            this.submitting = false;
            Swal.fire({
              type: 'error',
              title: 'Ops! Algo de errado aconteceu!',
              text: 'Formato de arquivo inválido.'
            });
          });
        }
        else{
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tamanho de arquivo inválido.'
          });
        }
      }
    }
    else {
      for (let field in this.formDocumento.controls) {
        let campo = this.formDocumento.get(field);
        campo.markAsTouched();
      }
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
        text: 'Verifique os campos obrigatórios e tente novamente.'
      });
    }
  }

  invalid(nome) {
    let input = this.formDocumento.get(nome);
    return input.touched && input.invalid;
  }

  onDocumentoSelect(e) {
    var files = e.target.files;
    var file = files[0];

    //this.getBase64(e);
    this.file = <File>e.target.files;
    this.file_name = this.file[0].name;
    this.file_name_upload = this.file[0].name.split('.');
    this.file_name_upload = this.file_name_upload[0] + moment().format('x') + '.' + this.file_name_upload[1];
  }

  getBase64(files) {
    let me = this;
    //let file = event.target.files[0];
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      //this.uploadImageBase64 = reader.result;
      //console.log(reader.result);
      return reader.result;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
      return "";
    };
 }



 handleInputChange(e) {

  this.onDocumentoSelect(e);
   var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

   var pattern = /image-*/;
   var reader = new FileReader();

    let extensions = false;
    let typeFile = file.type.split("/");

    if(file.size > 1127979){
      alert('Arquivo ultrapassa o tamanho máximo de 1MB!');
      this.formDocumento.controls.documento_arquivo.setValue(null);
      this.file_name = "Selecionar arquivo";
      return;
    }

    for(let type of this.img_extensions){

      if(type == typeFile[1]){
        extensions = true;
      }

    }
   if (!extensions) {
     alert('Formato invalido!'); 
     this.formDocumento.controls.documento_arquivo.setValue(null);
     this.file_name = "Selecionar arquivo";
     return;
   }
   reader.onload = this._handleReaderLoaded.bind(this);
   reader.readAsDataURL(file);
 }
 _handleReaderLoaded(e) {
   let reader = e.target;
   this.imageSrc = reader.result;
   //console.log(this.imageSrc)
 }

  



}
